module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding-abf1946aba8fc6e8a7793a60f1a0b302.webp";